import { defineStore } from 'pinia'

export const useRepairDrawerStore = defineStore('repairDrawer', {
  state: () => ({
    isOpen: false,
    openDeliveryClientDrawer: false,
    payload: {
      currentRepairFile: null,
      rentalFileId: null,
      refreshCurrentRepairFile: null,
      onUpdateCurrentRepairFile: null,
      onShowUpdateRepairFileStatusModal: null,
      onShowGuaranteeExtensionBoomerangModal: null,
      onOpenRentalWarningModal: null,
      onResetDeliveryClientState: null
    }
  }),
  actions: {
    openDrawer(payload, options = {}) {
      this.payload = {
        ...this.payload,
        ...payload
      }
      this.openDeliveryClientDrawer = options.openDeliveryClientDrawer === true
      this.isOpen = true
    },
    closeDrawer() {
      this.isOpen = false
      this.openDeliveryClientDrawer = false
    },
    updateCurrentRepairFile(currentRepairFile) {
      this.payload.currentRepairFile = currentRepairFile
    },
    resetDeliveryClientState() {
      this.openDeliveryClientDrawer = false
      if (typeof this.payload.onResetDeliveryClientState === 'function') {
        this.payload.onResetDeliveryClientState(false)
      }
    }
  }
})
